// import ScrollToTopButton from "@/src/Components/scrollTopButton/scrollTopButton";
import { useGlobalContext } from "@/src/context/GlobalContext";

import { FC, ReactNode, useEffect } from "react";

interface HomeLayoutsProps {
  children: ReactNode;
}

const HomeLayouts: FC<HomeLayoutsProps> = ({ children }) => {
  const { setIsTransparent } = useGlobalContext();
  useEffect(() => {
    setIsTransparent(true);

    return () => {
      setIsTransparent(false);
    };
  }, [setIsTransparent]);

  return (
    <main>
      <section>{children}</section>
      {/* <ScrollToTopButton /> */}
    </main>
  );
};

export default HomeLayouts;
